export default __webpack_public_path__ + "static/media/helsinki_s.ca60148f.jpg";